module.exports = __webpack_public_path__ + "assets/media/day6.d5ce4aa7.mp3";